/**
 * URL schemes we trust agent-authored hrefs to carry. Everything else
 * (`javascript:`, `data:`, `file:`, bare protocol-relative tricks, etc.) is
 * neutralized rather than rendered, since digest items and generative specs
 * are untrusted agent output.
 */
const ALLOWED_URL_SCHEMES = new Set(['http:', 'https:', 'mailto:']);
/**
 * Validate an agent-supplied href/link string against {@link ALLOWED_URL_SCHEMES}.
 *
 * @returns the original string when it parses as an absolute URL with an
 * allowed scheme, otherwise `null`.
 */
export function sanitizeHref(href) {
    if (!href)
        return null;
    try {
        const parsed = new URL(href);
        return ALLOWED_URL_SCHEMES.has(parsed.protocol) ? href : null;
    }
    catch {
        return null;
    }
}
